import React from 'react';
import { Drawer, Button, Typography, List, Space, Tag, Divider, message, Descriptions, Card } from 'antd';
import { ShoppingCartOutlined, DeleteOutlined, DollarOutlined, UserOutlined, EnvironmentOutlined, CalendarOutlined, PhoneOutlined, MailOutlined } from '@ant-design/icons';
import { useCart } from '../contexts/CartContext';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

const Cart = ({ visible, onClose }) => {
  const { cart, removeFromCart, getTotal } = useCart();
  const navigate = useNavigate();

  const handleCheckout = () => {
    if (cart.length === 0) {
      message.warning('Your cart is empty');
      return;
    }
    navigate('/checkout');
    onClose();
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return dayjs(dateString).format('MMM D, YYYY');
  };

  return (
    <Drawer
      title={
        <Space>
          <ShoppingCartOutlined />
          <span>Cart ({cart.length})</span>
        </Space>
      }
      placement="right"
      onClose={onClose}
      open={visible}
      width={500}
      extra={
        <Button type="primary" onClick={handleCheckout}>
          Checkout
        </Button>
      }
    >
      {cart.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '24px' }}>
          <Typography.Text type="secondary">Your cart is empty</Typography.Text>
        </div>
      ) : (
        <>
          <List
            dataSource={cart}
            renderItem={item => (
              <Card 
                style={{ marginBottom: 16 }}
                size="small"
                extra={
                  <Button
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => removeFromCart(item.id)}
                  />
                }
              >
                <div style={{ marginBottom: 16 }}>
                  <Typography.Title level={5} style={{ margin: 0 }}>
                    <UserOutlined /> {item.first_name} {item.last_name}
                  </Typography.Title>
                </div>
                
                <Descriptions column={1} size="small">
                  <Descriptions.Item label={<Space><EnvironmentOutlined /> State</Space>}>
                    {item.state_name}
                  </Descriptions.Item>
                  
                  {item.phone && (
                    <Descriptions.Item label={<Space><PhoneOutlined /> Phone</Space>}>
                      {item.phone}
                    </Descriptions.Item>
                  )}
                  
                  {item.email && (
                    <Descriptions.Item label={<Space><MailOutlined /> Email</Space>}>
                      {item.email}
                    </Descriptions.Item>
                  )}
                  
                  {item.birth_date && (
                    <Descriptions.Item label={<Space><CalendarOutlined /> Birth Date</Space>}>
                      {formatDate(item.birth_date)}
                    </Descriptions.Item>
                  )}
                  
                  {item.coverage_amount && (
                    <Descriptions.Item label="Coverage Amount">
                      {item.coverage_amount}
                    </Descriptions.Item>
                  )}
                  
                  {item.type_of_life_insurance && (
                    <Descriptions.Item label="Insurance Type">
                      {item.type_of_life_insurance}
                    </Descriptions.Item>
                  )}
                </Descriptions>

                <div style={{ 
                  marginTop: 16, 
                  padding: '8px 12px', 
                  backgroundColor: '#f5f5f5', 
                  borderRadius: '4px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  <Typography.Text type="secondary">Price</Typography.Text>
                  <Tag color="blue">${parseFloat(item.lead_price) || 0}</Tag>
                </div>
              </Card>
            )}
          />
          <Divider />
          <div style={{ padding: '0 16px' }}>
            <Space direction="vertical" style={{ width: '100%' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography.Text>Subtotal:</Typography.Text>
                <Typography.Text strong>${getTotal()}</Typography.Text>
              </div>
              <Button
                type="primary"
                block
                icon={<DollarOutlined />}
                onClick={handleCheckout}
              >
                Proceed to Checkout
              </Button>
            </Space>
          </div>
        </>
      )}
    </Drawer>
  );
};

export default Cart; 